import { ComparisonPoints } from "./comparison-points.js";
import { courseHoleAverages } from "../../../shared/presentation/course-hole-averages.js";
import { displaySides } from "./comparison-presentation.js";
import type { AnalysisProps } from "./comparison-observation.js";

export function HoleComparisons({ detail }: AnalysisProps): React.JSX.Element {
  const courses = courseHoleAverages(detail.holes);
  const sides = displaySides(detail.relation);
  return (
    <section className="rc-analysis rc-statistics rc-course-holes">
      {!courses.length ? (
        <p className="rc-empty">No shared hole scores yet.</p>
      ) : null}
      {courses.map((course) => (
        <details key={course.id} className="rc-course-holes-group">
          <summary>
            <span>{course.name}</span>
            <span aria-hidden="true">+</span>
          </summary>
          <p className="rc-caption">
            Average {detail.filters.basis === "net" ? "net" : "gross"} strokes /
            hole
          </p>
          {course.holes.map((row) => (
            <ComparisonPoints
              key={row.hole}
              label={`Hole ${row.hole}`}
              names={[
                detail.relation[sides[0]].name,
                detail.relation[sides[1]].name,
              ]}
              values={[row[sides[0]], row[sides[1]]]}
              description={`Average ${detail.filters.basis} strokes · Lower is better`}
              sample={`${row.n} rounds`}
            />
          ))}
        </details>
      ))}
    </section>
  );
}
